import { Dropdown } from 'antd';
import { Link } from 'react-router-dom'
import { IHeaderItems } from './types'
import {
  CaretDownOutlined, RadiusBottomleftOutlined,
} from '@ant-design/icons';
import { useState, Fragment } from 'react';
import { ItemType } from 'antd/es/menu/hooks/useItems';
import React from 'react';

function HeaderNavBar(props: {items: IHeaderItems[]}) {

  const [isOpen, setIsOpen] = useState<number | null>(null)

  const changeVisibility = (e: boolean, i: number) => {
    if(!e) return setIsOpen(null)
    setIsOpen(i)
  }

  function getChildItems(item:any) : ItemType[] {
    let items:ItemType[] = new Array<ItemType>();

    item.childs.forEach((element: any) => {
        items?.push({"key": item.name, "label": (
          <div className="header-navbar-submenu">
            <Link onClick={() => setIsOpen(null)} className="header-navbar-submenu__link" to={element.link}>
              <div id={`submenu_${element.name}`}>{element.name}</div>
            </Link>
          </div>
        ),
      },)
    });
  
    return items;
  }

  return (
    <div className="header-navbar mobile-hidden">
        {props.items.map((item, i) => (
          <Fragment key={item.name}>
            {item.childs && item.name !== 'Reports' ? (
              <div key={item.name} className="header-navbar__item">
                <Dropdown 
                  open={isOpen === i}
                  trigger={['click']} 
                  menu= {{items:getChildItems(item), style:{ backgroundColor: '#0f0101', padding: '0px', color: 'red', borderBottomLeftRadius:'20px', borderBottomRightRadius:'20px'}}}
                  placement="bottomLeft"
                  onOpenChange={(e) => changeVisibility(e, i)}
                >
                  <div className="header-navbar__item__link" id={`${item.name}`}>{item.name} <CaretDownOutlined /></div>
                </Dropdown>
              </div>
            ):(
              <div key={item.name} className="header-navbar__item">
                <Link className="header-navbar__item__link" id={item.name} to={item.name !== 'Reports' ? item.link : '/reports'}>{item.name}</Link>
              </div>
            )}
          </Fragment>
        ))}
    </div>
  )
}

export default HeaderNavBar
